<template>
  <b-row>
    <b-col cols="12" md="4">
      <custom-input
        v-model="innerValue.date_from"
        :name="$gettext('date from')"
        component="date"
        rules="required"
      />
    </b-col>
    <b-col cols="12" md="4">
      <custom-input
        rules="required"
        v-model="innerValue.date_to"
        :name="$gettext('date to')"
        component="date"
      />
    </b-col>
  </b-row>
</template>

<script>
import vModelMixin from '@/shared/mixins/v-model'

export default {
  mixins: [vModelMixin],
}
</script>
